import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  endImpersonation,
  getDecoded,
  isImpersonating,
  onChange,
} from '@/lib/auth';
import { useT } from '@/lib/i18n';

export function ImpersonationBanner() {
  const t = useT();
  const nav = useNavigate();
  const [active, setActive] = useState<boolean>(isImpersonating());
  const [tenantId, setTenantId] = useState<string>(
    getDecoded()?.tenant_id ?? ''
  );

  useEffect(() => {
    return onChange(() => {
      setActive(isImpersonating());
      setTenantId(getDecoded()?.tenant_id ?? '');
    });
  }, []);

  if (!active) return null;

  const onExit = async () => {
    await endImpersonation();
    nav('/superadmin/tenants');
  };

  return (
    <div className="sticky top-0 z-40 flex items-center justify-between gap-3 border-b border-amber-300/40 bg-amber-50 dark:bg-amber-900/30 px-3 py-2 text-sm">
      <div className="flex items-center gap-2 text-amber-900 dark:text-amber-100">
        <ShieldAlert className="h-4 w-4 shrink-0" />
        <span className="truncate">
          {t('superadmin.banner.impersonating')}{' '}
          <span className="font-mono font-semibold">{tenantId}</span>
        </span>
      </div>
      <Button size="sm" variant="outline" onClick={onExit} className="shrink-0">
        {t('superadmin.banner.exit')}
      </Button>
    </div>
  );
}
